import {
  IoBusinessOutline,
  IoChatbubblesOutline,
  IoGlobeSharp,
  IoHeartCircleOutline,
  IoPeopleOutline,
} from "react-icons/io5";

export const SidebarPath = [
  {
    name: "Dashboard",
    path: "/",
    icon: <IoGlobeSharp />,
  },
  {
    name: "Organization",
    path: "/organization",
    icon: <IoBusinessOutline />,
  },
  {
    name: "Services",
    path: "/services",
    icon: <IoHeartCircleOutline />,
  },
  {
    name: "Careers",
    path: "/careers",
    icon: <IoPeopleOutline />,
  },
  {
    name: "Messages",
    path: "/messages",
    icon: <IoChatbubblesOutline />,
  },
];
